<template>
  <b-form-group
    label="İçerik Alt Metin"
    label-for="content_sub_title"
  >
    <validation-provider
      #default="{ errors }"
      name="İçerik Alt Metin"
      rules="required"
    >
      <b-form-textarea
        id="content_sub_title"
        v-model="itemData.content_sub_title"
        placeholder="İçerik Alt Metin"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormTextarea } from 'bootstrap-vue'

export default {
  name: 'ContentSubTitle',
  components: {
    BFormGroup,
    BFormTextarea,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['productCategories/dataItem']
    },
  },
}
</script>
